import translations from './tellurium.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/tellurium'

export const tellurium: Metal = {
  id: 33,
  slug: 'tellurium',
  name: t.name,
  symbol: 'Te',
  // Processing facilities, not mines; coordinates geocoded from the sheet's place names.
  mines: [
    {
      name: 'Amarillo, tellurium processing facility (United States)',
      region: 'Amarillo',
      coordinates: [-101.83, 35.22],
    },
    {
      name: 'Magna, tellurium processing facility (United States)',
      region: 'Magna',
      coordinates: [-112.1, 40.71],
    },
    {
      name: 'Skellefteå, tellurium processing facility (Sweden)',
      region: 'Skellefteå',
      coordinates: [20.95, 64.75],
    },
    {
      name: 'Kyshtym, tellurium processing facility (Russia)',
      region: 'Kyshtym',
      coordinates: [60.55, 55.7],
    },
  ],
  // Refined output, not mine production — see the `**` footnote.
  countries: [{ name: 'China', percent: 75 }],
  // All three carry tellurium into the refineries it is recovered from.
  related: ['copper', 'lead', 'zinc'],
  content: {
    smartphone: {
      quantityScore: 1,
      quantityLabel: t.smartphone.label,
      parts: ['electronics'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 2, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 5, ...t.supplyRisk },
    recycling: { score: 1, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
        },
      ],
    },
  },
}
